import { render, staticRenderFns } from "./NotificationsSettingsFormAssets.vue?vue&type=template&id=3239fbee"
import script from "./NotificationsSettingsFormAssets.vue?vue&type=script&lang=js"
export * from "./NotificationsSettingsFormAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports